import { render, staticRenderFns } from "./exitBuddy.popup-chunk.vue?vue&type=template&id=458965ef&scoped=true"
import script from "./exitBuddy.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./exitBuddy.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./exitBuddy.popup-chunk.vue?vue&type=style&index=0&id=458965ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458965ef",
  null
  
)

export default component.exports